import { render, staticRenderFns } from "./WellTermination.vue?vue&type=template&id=8a5b7b42"
import script from "./WellTermination.vue?vue&type=script&lang=js"
export * from "./WellTermination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports